import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  Injectable,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
  ViewChild,
} from "@angular/core";
import { FormControl, FormGroup } from "@angular/forms";
import { MatSort } from "@angular/material/sort";
import { UserService } from "src/app/services/user.service";
import { DeviceService } from "src/app/services/device.service";
import { MatTableDataSource } from "@angular/material/table";
import { MatPaginator, MatPaginatorIntl } from "@angular/material/paginator";
import { Subscription, forkJoin } from "rxjs";
import { Router } from "@angular/router";
import { Error429Service } from "src/app/services/error429.service";
import * as ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import { UserDataService } from "src/app/services/user-data.service";

@Component({
  selector: "app-alarmas-historial",
  templateUrl: "./alarmas-historial.component.html",
  styleUrls: ["./alarmas-historial.component.css"],
})
export class AlarmasHistorialComponent {
  userEstablecimientos: any[] = []; //Información básica de cada uno de los dispositivos
  devicesAndEstablishmentInfo: any[] = []; //Información completa de los dispositivos y establecimientos
  devicesReferences: string = ""; //String con los dispositivos de los que necesitamos información
  datosRecibidos: boolean = false; // Variable para controlar la visibilidad de los datos recibidos
  errorMessage: string = ""; //Mensaje de error
  displayedColumns: string[] = [
    "dev_reference",
    "dev_label",
    "est_name",
    "f_inicio",
    "f_fin",
    "type",
    "alarm_range",
  ];
  dataSource: any;
  alarmas: any = [];
  devices: any = [];
  alarmasData: any = [];
  establecimientosId: any = [];
  alarmLists: any = [];
  totalAlarms: number = 0;
  currentPage: number = 1;
  perPage: number = 20;
  sortField: string = "";
  sortOrder: string = "";
  searchFilter: string = "";
  establishments: any;

  modalidad: any[] = [
    { value: 0, name: "Todas" },
    { value: 1, name: "Tanque" },
    { value: 2, name: "Dispositivo" },
  ];
  selectedModalidad: number = 0;
  userData: any = [];
  message: string = "";

  //FECHAS
  fechaActual: Date = new Date();
  dia: number = this.fechaActual.getDate();
  mes: number = this.fechaActual.getMonth();
  anio: number = this.fechaActual.getFullYear();
  fechaMinima = new Date(this.anio, this.mes, this.dia);

  selectedDateRange = new FormGroup({
    start: new FormControl(),
    end: new FormControl(),
  });

  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild(MatPaginator) paginator!: MatPaginator;

  private alarmasSubscription: Subscription | undefined;
  private establecimientoSubscription: Subscription | undefined;

  constructor(
    private deviceService: DeviceService,
    private router: Router,
    private error429: Error429Service,
    private userDataService: UserDataService,
    public cdr: ChangeDetectorRef
  ) {
    this.userData = this.userDataService.getUserData();
  }

  ngOnInit(): void {
    const startDate = new Date(this.anio, this.mes - 1, this.dia);
    this.selectedDateRange.setValue({
      start: startDate,
      end: this.convertirFecha(this.fechaActual),
    });

    this.loadAlarmHistory();
  }

  ngAfterViewChecked() {
    if (this.paginator && this.paginator.length !== this.totalAlarms) {
      this.paginator.length = this.totalAlarms;
      this.paginator.pageIndex = this.currentPage - 1;
      this.cdr.detectChanges(); // Force re-render
    }
  }

  loadAlarmHistory() {
    this.message = "";
    if (
      this.selectedDateRange.value.start == null ||
      this.selectedDateRange.value.end == null
    ) {
      this.message =
        "Por favor seleccione tanto la fecha de inicio como la de finalización";
    } else {
      this.establecimientoSubscription = this.deviceService
        .getDevicesAllDataNew()
        .subscribe({
          next: (resp) => {
            for (let x = 0; x < resp.length; x++) {
              this.establecimientosId.push(resp[x].id);
              for (let j = 0; j < resp[x].devices.length; j++) {
                this.devices.push(resp[x].devices[j]);
              }
            }
          },
          error: (err) => {
            console.log(err.error);
            if (err.status == 429) {
              this.errorMessage =
                "Se han mandado demasiadas peticiones, espere un momento por favor";
              this.recargarPaginaDespuesDeTiempo();
            } else {
              this.errorMessage = err.error.message;
            }
          },
          complete: () => {
            let start = this.convertirFechaInicio(this.selectedDateRange);
            let end = this.convertirFechaFin(this.selectedDateRange);

            const alarmasEstablecimientos = new FormData();
            alarmasEstablecimientos.append(
              "establishments",
              JSON.stringify(this.establecimientosId)
            );
            alarmasEstablecimientos.append("start", start);
            alarmasEstablecimientos.append("end", end);
            this.establishments = alarmasEstablecimientos;

            this.alarmasSubscription = this.deviceService
              .getAlarmasEstablecimientos(
                alarmasEstablecimientos,
                this.currentPage,
                this.perPage,
                this.sortField,
                this.sortOrder,
                this.searchFilter,
                this.selectedModalidad
              )
              .subscribe({
                next: (resp) => {
                  this.alarmas = [];
                  this.alarmLists = resp.alarms.data;
                  this.totalAlarms = resp.alarms.total;

                  setTimeout(() => {
                    if (this.paginator) {
                      this.paginator.length = this.totalAlarms;
                      this.paginator.pageIndex = this.currentPage - 1;
                      this.cdr.detectChanges();
                    }
                  });

                  this.alarmas = this.processDataSet(resp);
                  /*for (let i = 0; i < resp.alarms.length; i++) {
                    if (resp.alarms[i].status !== 1) {
                      const tankJson = JSON.parse(resp.alarms[i].tank);
                      let alarmRange = "-";
                      if (tankJson) {
                        const alarmRanges = JSON.parse(tankJson.alarm_ranges);
                        if (
                          resp.alarms[i].type == "L1" ||
                          resp.alarms[i].type == "L2" ||
                          resp.alarms[i].type == "L3" ||
                          resp.alarms[i].type == "L4"
                        ) {
                          alarmRange =
                            "Nivel de cerveza mínimo: " +
                            this.soloDosDecimalesConComa(
                              alarmRanges.beerLevelMin
                            ) +
                            "%";
                        }
                        if (
                          resp.alarms[i].type == "A1" ||
                          resp.alarms[i].type == "A2" ||
                          resp.alarms[i].type == "A3" ||
                          resp.alarms[i].type == "A4"
                        ) {
                          alarmRange =
                            "Temperatura máxima: " +
                            this.soloDosDecimalesConComa(
                              alarmRanges.beerTemperatureMax
                            ) +
                            "ºC";
                        }
                        if (
                          resp.alarms[i].type == "B1" ||
                          resp.alarms[i].type == "B2" ||
                          resp.alarms[i].type == "B3" ||
                          resp.alarms[i].type == "B4"
                        ) {
                          alarmRange =
                            "Temperatura mínima: " +
                            this.soloDosDecimalesConComa(
                              alarmRanges.beerTemperatureMin
                            ) +
                            "ºC";
                        }
                        if (
                          resp.alarms[i].type == "C1" ||
                          resp.alarms[i].type == "C2" ||
                          resp.alarms[i].type == "C3" ||
                          resp.alarms[i].type == "C4"
                        ) {
                          if (alarmRanges.beerPressureMax == 1) {
                            alarmRange =
                              "Presión máxima: " +
                              this.soloDosDecimalesConComa(
                                alarmRanges.beerPressureMax
                              ) +
                              " bar";
                          } else {
                            alarmRange =
                              "Presión máxima: " +
                              this.soloDosDecimalesConComa(
                                alarmRanges.beerPressureMax
                              ) +
                              " bares";
                          }
                        }
                        if (
                          resp.alarms[i].type == "D1" ||
                          resp.alarms[i].type == "D2" ||
                          resp.alarms[i].type == "D3" ||
                          resp.alarms[i].type == "D4"
                        ) {
                          if (alarmRanges.beerPressureMin == 1) {
                            alarmRange =
                              "Presión mínima: " +
                              this.soloDosDecimalesConComa(
                                alarmRanges.beerPressureMin
                              ) +
                              " bar";
                          } else {
                            alarmRange =
                              "Presión mímina: " +
                              this.soloDosDecimalesConComa(
                                alarmRanges.beerPressureMin
                              ) +
                              " bares";
                          }
                        }
                      }
                      let type = resp.alarms[i].desc2;
                      this.alarmas.push({
                        dev_reference: this.obtenerDeviceReference(
                          resp.alarms[i].device_id
                        ),
                        dev_label: this.obtenerDeviceLabel(
                          resp.alarms[i].device_id
                        ),
                        est_name: resp.alarms[i].establishment.est_name,
                        f_inicio: resp.alarms[i].started_at,
                        f_fin: resp.alarms[i].ended_at,
                        type: type ?? "-",
                        type_simbol: resp.alarms[i].type,
                        alarm_range: alarmRange,
                        est_id: resp.alarms[i].establishment_id,
                        dev_id: resp.alarms[i].device_id,
                      });
                    }
                  } */
                },
                error: (err) => {
                  if (err.status == 429) {
                    this.errorMessage =
                      "Se han mandado demasiadas peticiones, espere un momento por favor";
                    this.recargarPaginaDespuesDeTiempo();
                  } else {
                    this.errorMessage = err.error.message;
                  }
                },
                complete: () => {
                  this.dataSource = new MatTableDataSource(this.alarmas);
                  //Filtrado personalizado
                  this.dataSource.filterPredicate = (
                    data: any,
                    filter: string
                  ) => {
                    const dataStr = this.displayedColumns
                      .filter(
                        (key) =>
                          key !== "est_id" &&
                          key !== "dev_id" &&
                          key !== "type_simbol"
                      )
                      .map((key) => data[key])
                      .join("")
                      .toLowerCase();

                    return dataStr.includes(filter);
                  };
                  setTimeout(() => {
                    this.dataSource.sort = this.sort;
                    this.dataSource.paginator = this.paginator;
                  }, 0);
                  this.datosRecibidos = true;
                },
              });
          },
        });
    }
  }

  processDataSet(dataSet: any): any {
    const alarms: any = [];
    for (let i = 0; i < dataSet.alarms.data.length; i++) {
      if (dataSet.alarms.data[i].status !== 1) {
        const tankJson = JSON.parse(dataSet.alarms.data[i].tank);
        let alarmRange = "-";
        if (tankJson) {
          const alarmRanges = JSON.parse(tankJson.alarm_ranges);
          if (
            dataSet.alarms.data[i].type == "L1" ||
            dataSet.alarms.data[i].type == "L2" ||
            dataSet.alarms.data[i].type == "L3" ||
            dataSet.alarms.data[i].type == "L4"
          ) {
            alarmRange =
              "Nivel de cerveza mínimo: " +
              this.soloDosDecimalesConComa(alarmRanges.beerLevelMin) +
              "%";
          }
          if (
            dataSet.alarms.data[i].type == "A1" ||
            dataSet.alarms.data[i].type == "A2" ||
            dataSet.alarms.data[i].type == "A3" ||
            dataSet.alarms.data[i].type == "A4"
          ) {
            alarmRange =
              "Temperatura máxima: " +
              this.soloDosDecimalesConComa(alarmRanges.beerTemperatureMax) +
              "ºC";
          }
          if (
            dataSet.alarms.data[i].type == "B1" ||
            dataSet.alarms.data[i].type == "B2" ||
            dataSet.alarms.data[i].type == "B3" ||
            dataSet.alarms.data[i].type == "B4"
          ) {
            alarmRange =
              "Temperatura mínima: " +
              this.soloDosDecimalesConComa(alarmRanges.beerTemperatureMin) +
              "ºC";
          }
          if (
            dataSet.alarms.data[i].type == "C1" ||
            dataSet.alarms.data[i].type == "C2" ||
            dataSet.alarms.data[i].type == "C3" ||
            dataSet.alarms.data[i].type == "C4"
          ) {
            if (alarmRanges.beerPressureMax == 1) {
              alarmRange =
                "Presión máxima: " +
                this.soloDosDecimalesConComa(alarmRanges.beerPressureMax) +
                " bar";
            } else {
              alarmRange =
                "Presión máxima: " +
                this.soloDosDecimalesConComa(alarmRanges.beerPressureMax) +
                " bares";
            }
          }
          if (
            dataSet.alarms.data[i].type == "D1" ||
            dataSet.alarms.data[i].type == "D2" ||
            dataSet.alarms.data[i].type == "D3" ||
            dataSet.alarms.data[i].type == "D4"
          ) {
            if (alarmRanges.beerPressureMin == 1) {
              alarmRange =
                "Presión mínima: " +
                this.soloDosDecimalesConComa(alarmRanges.beerPressureMin) +
                " bar";
            } else {
              alarmRange =
                "Presión mímina: " +
                this.soloDosDecimalesConComa(alarmRanges.beerPressureMin) +
                " bares";
            }
          }
        }
        let type = dataSet.alarms.data[i].desc2;

        alarms.push({
          dev_reference: dataSet.alarms.data[i].dev_reference,
          dev_label: dataSet.alarms.data[i].dev_label,
          est_name: dataSet.alarms.data[i].est_name,
          f_inicio: dataSet.alarms.data[i].started_at,
          f_fin: dataSet.alarms.data[i].ended_at,
          type: type ?? "-",
          type_simbol: dataSet.alarms.data[i].type,
          alarm_range: alarmRange,
          est_id: dataSet.alarms.data[i].establishment_id,
          dev_id: dataSet.alarms.data[i].device_id,
        });

        console.log(alarms);
      }
    }

    return alarms;
  }

  convertirFecha(fecha: Date): string {
    const año = fecha.getFullYear();
    const mes = (fecha.getMonth() + 1).toString().padStart(2, "0");
    const dia = fecha.getDate().toString().padStart(2, "0");
    return `${año}-${mes}-${dia}`;
  }

  convertirFechaInicio(selectedDate: FormGroup): string {
    if (selectedDate.value.start) {
      const fecha = new Date(selectedDate.value.start);
      const year = fecha.getFullYear();
      const month = (fecha.getMonth() + 1).toString().padStart(2, "0");
      const day = fecha.getDate().toString().padStart(2, "0");
      const fechaFormateada = `${year}-${month}-${day}`;
      return fechaFormateada;
    }
    return "";
  }

  convertirFechaFin(selectedDate: FormGroup): string {
    if (selectedDate.value.end) {
      const fecha = new Date(selectedDate.value.end);
      const year = fecha.getFullYear();
      const month = (fecha.getMonth() + 1).toString().padStart(2, "0");
      const day = fecha.getDate().toString().padStart(2, "0");
      const fechaFormateada = `${year}-${month}-${day}`;
      return fechaFormateada;
    }
    return "";
  }

  changeDateRange(event: any, type: string) {
    if (
      type == "end" &&
      this.selectedDateRange.value.start != null &&
      this.selectedDateRange.value.end != null
    ) {
      this.currentPage = 1;
      this.loadAlarmHistory();
    }
  }

  onPageChange(event: any) {
    this.currentPage = event.pageIndex + 1;
    this.perPage = event.pageSize;
    this.loadAlarmHistory();
  }

  onSortChange(event: any) {
    this.sortField = event.active;
    this.sortOrder = event.direction || "asc";
    this.currentPage = 1;
    this.loadAlarmHistory();
  }

  soloDosDecimalesConComa(numero: number) {
    if (Number.isNaN(numero)) {
      return "--";
    } else {
      return numero.toLocaleString(this.userData.region, {
        maximumFractionDigits: 2,
      });
    }
  }

  onModalidadChange() {
    this.currentPage = 1;
    this.loadAlarmHistory();

    /*
    const dispositivoTypes = ["T", "R", "E", "M", "TT", "RR", "EE", "MM", "OO"];
    const tanquesTypes = [
      "L1",
      "L2",
      "L3",
      "L4",
      "A1",
      "A2",
      "A3",
      "A4",
      "B1",
      "B2",
      "B3",
      "B4",
      "C1",
      "C2",
      "C3",
      "C4",
      "D1",
      "D2",
      "D3",
      "D4",
    ];
    if (this.selectedModalidad == 0) {
      this.dataSource = new MatTableDataSource(this.alarmas);
      this.dataSource.sort = this.sort;
      this.dataSource.paginator = this.paginator;
      this.dataSource.filterPredicate = (data: any, filter: string) => {
        const dataStr = this.displayedColumns
          .filter(
            (key) =>
              key !== "est_id" && key !== "dev_id" && key !== "type_simbol"
          )
          .map((key) => data[key])
          .join("")
          .toLowerCase();

        return dataStr.includes(filter);
      };
    }
    if (this.selectedModalidad == 1) {
      const alarmasTanque = this.alarmas.filter((alarma: any) =>
        tanquesTypes.includes(alarma.type_simbol)
      );
      // Actualiza el dataSource con la nueva lista filtrada
      this.dataSource = new MatTableDataSource(alarmasTanque);
      this.dataSource.sort = this.sort;
      this.dataSource.paginator = this.paginator;
      this.dataSource.filterPredicate = (data: any, filter: string) => {
        const dataStr = this.displayedColumns
          .filter(
            (key) =>
              key !== "est_id" && key !== "dev_id" && key !== "type_simbol"
          )
          .map((key) => data[key])
          .join("")
          .toLowerCase();

        return dataStr.includes(filter);
      };
    }
    if (this.selectedModalidad == 2) {
      const alarmasDispositivo = this.alarmas.filter((alarma: any) =>
        dispositivoTypes.includes(alarma.type_simbol)
      );
      this.dataSource = new MatTableDataSource(alarmasDispositivo);
      this.dataSource.sort = this.sort;
      this.dataSource.paginator = this.paginator;
      this.dataSource.filterPredicate = (data: any, filter: string) => {
        const dataStr = this.displayedColumns
          .filter(
            (key) =>
              key !== "est_id" && key !== "dev_id" && key !== "type_simbol"
          )
          .map((key) => data[key])
          .join("")
          .toLowerCase();

        return dataStr.includes(filter);
      };
    }
    */
  }

  ngOnDestroy(): void {
    if (this.alarmasSubscription) {
      this.alarmasSubscription.unsubscribe();
    }
    if (this.establecimientoSubscription) {
      this.establecimientoSubscription.unsubscribe();
    }
  }

  descargarExcel() {
    this.message = "";
    let alarms: any = [];
    this.deviceService
      .getAlarmasEstablecimientos(
        this.establishments,
        this.currentPage,
        this.perPage,
        this.sortField,
        this.sortOrder,
        this.searchFilter,
        this.selectedModalidad,
        1
      )
      .subscribe({
        next: (resp) => {
          alarms = this.processDataSet(resp);
          if (alarms.length > 0) {
            const workbook = new ExcelJS.Workbook();
            const worksheet = workbook.addWorksheet("Datos");

            worksheet.columns = [
              { header: "Ref.Dispositivo", key: "dev_reference", width: 10 },
              { header: "Nombre Disp.", key: "dev_label", width: 10 },
              { header: "Establecimiento", key: "est_name", width: 30 },
              { header: "Fecha Inicio", key: "f_inicio", width: 30 },
              { header: "Fecha Fin", key: "f_fin", width: 30 },
              { header: "Tipo", key: "type", width: 30 },
              { header: "Rango de Alarma", key: "alarm_range", width: 30 },
            ];

            alarms.forEach((alarma: any) => {
              const formattedAlarma = {
                dev_reference: alarma.dev_reference,
                dev_label: alarma.dev_label,
                est_name: alarma.est_name,
                f_inicio: alarma.f_inicio,
                f_fin: alarma.f_fin,
                type: alarma.type,
                alarm_range: alarma.alarm_range,
              };
              const row = worksheet.addRow(formattedAlarma);
              row.eachCell({ includeEmpty: true }, (cell, colNumber) => {
                const columnWidth = cell.text.length + 3;
                const currentColumn = worksheet.getColumn(colNumber);
                if (currentColumn) {
                  currentColumn.width = Math.max(
                    currentColumn.width || 0,
                    columnWidth
                  );
                }
              });
            });
            workbook.xlsx.writeBuffer().then((buffer) => {
              const blob = new Blob([buffer], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
              });
              saveAs(blob, "Historial de alarmas DataBeer.xlsx");
            });

            if (this.totalAlarms > 1000) {
              this.message =
                "Solo se pueden exportar 1000 registros. Seleccione una cantidad menor de datos";
            }
          }
        },
        error: (err) => {
          this.errorMessage = err.error.message;
        },
        complete: () => {},
      });
  }

  obtenerDeviceReference(deviceId: number) {
    const device = this.devices.find(
      (device: any) => device && device.id === deviceId
    );
    return device ? device.dev_reference : "Referencia no encontrada";
  }

  obtenerDeviceLabel(deviceId: number) {
    const device = this.devices.find(
      (device: any) => device && device.id === deviceId
    );
    return device ? device.dev_label : "Etiqueta no encontrada";
  }

  recargarPaginaDespuesDeTiempo() {
    this.error429.setError(true);
    window.location.reload();
  }

  //Función para buscar en la tabla
  applyFilter(event: Event) {
    this.searchFilter = (event.target as HTMLInputElement).value;
    this.currentPage = 1;
    this.loadAlarmHistory();
  }
}
